import { useTheSidebarProps } from "./fetch";
import { TheSidebarUi } from "./ui";

type Props = {
  mobileOpen: boolean;
  onMobileClose: () => void;
};

export const TheSidebar = ({ mobileOpen, onMobileClose }: Props) => {
  const props = useTheSidebarProps();
  return (
    <TheSidebarUi
      {...props}
      mobileOpen={mobileOpen}
      onMobileClose={onMobileClose}
    />
  );
};
